import { IconComponent } from './types';

const GridIcon: IconComponent = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_615_6277"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <rect width="12" height="12" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_615_6277)">
        <path
          d="M0.526001 0.507599H1.01152V11.1007H0.526001V0.507599Z"
          fill="currentColor"
        />
        <path
          d="M5.41013 0.507599H5.89564V6.06899H5.41013V0.507599Z"
          fill="currentColor"
        />
        <path
          d="M1.51724 0.758621C1.51724 1.1776 1.1776 1.51724 0.758621 1.51724C0.339646 1.51724 0 1.1776 0 0.758621C0 0.339646 0.339646 0 0.758621 0C1.1776 0 1.51724 0.339646 1.51724 0.758621Z"
          fill="currentColor"
        />
        <path
          d="M1.51724 6.00001C1.51724 6.41898 1.1776 6.75863 0.758621 6.75863C0.339646 6.75863 0 6.41898 0 6.00001C0 5.58103 0.339646 5.24138 0.758621 5.24138C1.1776 5.24138 1.51724 5.58103 1.51724 6.00001Z"
          fill="currentColor"
        />
        <path
          d="M1.51724 11.2414C1.51724 11.6604 1.1776 12 0.758621 12C0.339646 12 0 11.6604 0 11.2414C0 10.8224 0.339646 10.4828 0.758621 10.4828C1.1776 10.4828 1.51724 10.8224 1.51724 11.2414Z"
          fill="currentColor"
        />
        <path
          d="M6.4115 0.758621C6.4115 1.1776 6.07185 1.51724 5.65288 1.51724C5.2339 1.51724 4.89426 1.1776 4.89426 0.758621C4.89426 0.339646 5.2339 0 5.65288 0C6.07185 0 6.4115 0.339646 6.4115 0.758621Z"
          fill="currentColor"
        />
        <path
          d="M6.4115 6.00001C6.4115 6.41898 6.07185 6.75863 5.65288 6.75863C5.2339 6.75863 4.89426 6.41898 4.89426 6.00001C4.89426 5.58103 5.2339 5.24138 5.65288 5.24138C6.07185 5.24138 6.4115 5.58103 6.4115 6.00001Z"
          fill="currentColor"
        />
        <path
          d="M10.6207 0.758621C10.6207 1.1776 10.281 1.51724 9.86208 1.51724C9.4431 1.51724 9.10345 1.1776 9.10345 0.758621C9.10345 0.339646 9.4431 0 9.86208 0C10.281 0 10.6207 0.339646 10.6207 0.758621Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default GridIcon;
